import DiagnosticsModule from '@modules/DiagnosticsModule';
import { AgentMetricNames, AgentMetricTags, Source } from './agentMetrics';
import { UserSetAvailabilityStatus } from '@api/generated/graphql';

/**
 * Records agent status changes for baseline reliability metrics.
 *
 * Status changes can be:
 * - Manual: Agent-initiated via UI (Available → Break, Break → Available, etc.)
 * - Automatic: System-initiated via RTCS events (e.g., post-call wrapup)
 *
 * This establishes baseline for future comparison to validate
 * that agents follow manual workflow in degraded mode.
 */
export function recordAgentStatusChange(
  fromStatus: UserSetAvailabilityStatus | string,
  toStatus: UserSetAvailabilityStatus | string,
  source: (typeof Source)[keyof typeof Source],
): void {
  try {
    DiagnosticsModule.incrementCounter(AgentMetricNames.STATUS_CHANGE_TOTAL, {
      [AgentMetricTags.SOURCE]: source,
      [AgentMetricTags.AGENT_STATUS_FROM]: String(fromStatus),
      [AgentMetricTags.AGENT_STATUS_TO]: String(toStatus),
    });
  } catch (error) {
    // Metrics are non-critical - log warning but don't throw
    console.warn('Failed to record status change metric:', error);
  }
}
